<template>
  <div>
    <MaxTable ref="MaxTableSqlResults" :canExport="false"></MaxTable>
    <div v-if="log || results.length">
      <Tabs type="card" v-model="sqlTab" @on-click="refreshExecuteLog" name="sqlResultTab" :animated='false'>
        <TabPane label="执行记录" v-if="log" tab="sqlResultTab" :index='1'>
          <Table ref="executeLogTable" :loading="execLog.loading" :data="execLog.data" :columns="execLog.columns" size="small"/>
          <Row style="margin: 10px;">
            <div style="float: right;">
              <page :total="execLog.count" :current="execLog.page" :page-size="execLog.size" @on-change="getExecuteLog"></page>
            </div>
          </Row>
        </TabPane>
        <TabPane v-for="(resTab, index) in results" :key="resTab.id" :label="'结果' + resTab.id" tab="sqlResultTab" :index='index+2'>

            <Row>
              <Alert show-icon v-if="resTab.msg">{{ resTab.msg }}</Alert>
              <a v-on:click="fullTable($event, index, '结果' + resTab.id)" style="float: right">全屏</a>
            </Row>
            <Row>
              <Table v-if="resTab.res.length < 100" ref="resTable" :height="resTab.res.length > 5 ? 300 : 0" :data="resTab.res" :columns="resTab.columns" size="small"/>
              <Table v-else :height="resTab.res.length > 5 ? 300 : 0" ref="resTable" :data="resTab.res.slice((resTab.page - 1) * resTab.size, (resTab.page - 1) * resTab.size + resTab.size)" :columns="resTab.columns" size="small" :key="tableKey" />
            </Row>
            <Row v-if="resTab.res.length >= 100" style="margin: 10px;">
              <div style="float: right;">
                <page :total="resTab.count" :current="resTab.page" :page-size="resTab.size" @on-change="(page) => resTabOnChange(page, resTab)"></page>
              </div>
            </Row>

        </TabPane>
      </Tabs>

      <!-- <Modal ref="sqlResultModal" :title="sqlResultTitle" v-model="sqlResultIsShow" fullscreen :footer-hide="true">
        <Table ref="maxTable" :data="sqlResultData" :columns="sqlResultColumns" />
      </Modal> -->
    </div>
  </div>

</template>

<script>
import { getExecuteLog, createExecuteLog } from '@/api/workflow/mysql'
import MaxTable from '@/view/components/modal/max-table'
import excel from '@/libs/excel'
export default {
  name: 'sqlResults',
  components: {
    MaxTable
  },
  props: {
    log: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    sql: {
      type: String,
      default: ''
    },
    callbackdata: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      sqlTab: 0,
      tableKey: 1,
      execLog: {
        data: [],
        columns: [
          {
            title: '时间',
            key: 'create_time',
            align: 'center',
            width: 165,
            render: (h, params) => {
              return h('div', new Date(params.row.create_time).toLocaleString())
            }
          },
          { title: '数据库', key: 'db', width: 150, align: 'center' },
          { title: 'SQL', key: 'sql', tooltip: true },
          { title: '执行时间(s)', key: 'execute_time', width: 150, align: 'center' },
          { title: '执行结果',
            key: 'is_failed',
            width: 120,
            render: (h, params) => {
              return h('div', params.row.is_failed ? '执行失败' : '执行成功')
            }
          }
        ],
        count: 0,
        page: 1,
        size: 5,
        loading: false
      },
      results: [],
      sqlResultIsShow: false,
      sqlResultTitle: '',
      sqlResultData: [],
      sqlResultColumns: []
    }
  },
  mounted () {
    this.getExecuteLog()
  },
  methods: {
    // 刷新执行记录
    refreshExecuteLog (name) {
      this.sqlTab = name
      if (!name) {
        this.getExecuteLog()
      }
    },
    // 获取执行记录
    getExecuteLog (value = 1) {
      if (typeof value === 'number') {
        this.execLog.page = value
      }
      let params = {
        instance_id: this.callbackdata.instance_id,
        page: this.execLog.page,
        size: this.execLog.size,
        execute_user_id: this.$store.state.user.userId
      }

      this.execLog.loading = true
      getExecuteLog(params).then(res => {
        this.execLog.data = res.data.results
        this.execLog.count = res.data.count
        this.execLog.loading = false
      }).catch(res => {
        this.execLog.loading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取数据列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取数据列表失败！服务器无响应'
          })
        }
      })
    },
    // 展示结果
    showResult (results) {
      this.results = results
      this.tableKey = Math.random()
      if (this.log) {
        this.sqlTab = 1
      } else {
        this.sqlTab = 0
      }
    },
    // 全屏查看表格
    fullTable (event, index, title) {
      event.stopPropagation() // 阻止事件冒泡
      const _data = JSON.parse(JSON.stringify(this.results[index].res))
      const _columns = JSON.parse(JSON.stringify(this.results[index].columns))
      console.log(_data, _columns, title)
      // this.sqlResultTitle = title
      // this.sqlResultData = _data
      // this.sqlResultColumns = _columns
      // this.sqlResultIsShow = true
      this.$refs.MaxTableSqlResults.showModal(_data, _columns, title)
    },
    // 导出
    exportData (type) {
      if (!this.sqlTab && this.log) {
        this.$refs.executeLogTable.exportCsv({
          filename: `executeLog-${(new Date()).valueOf()}.csv`
        })
      } else {
        if (type === 'csv') {
          this.$refs.resTable[this.log ? this.sqlTab - 1 : this.sqlTab].exportCsv({
            filename: `query-${(new Date()).valueOf()}.csv`,
            original: false, // 是否导出为原始数据,默认为true
            columns: this.results[this.log ? this.sqlTab - 1 : this.sqlTab].columns,
            data: this.results[this.log ? this.sqlTab - 1 : this.sqlTab].res
          })
        } else {
          const keys = this.results[this.log ? this.sqlTab - 1 : this.sqlTab].columns.map((item) => item.key)
          excel.export_array_to_excel({
            title: keys,
            key: keys,
            data: this.results[this.log ? this.sqlTab - 1 : this.sqlTab].res,
            autoWidth: true,
            filename: `query-${(new Date()).valueOf()}`
          })
        }
      }
      createExecuteLog({
        instance: this.callbackdata.instance_id,
        db: this.callbackdata.db,
        sql: this.sql ? '导出表格记录, 语句如下: ' + this.sql : '导出执行记录',
        is_failed: 0,
        execute_user: this.$store.state.user.userId
      })
    },

    generateInsertStatement (tableName, data) {
      if (!Array.isArray(data)) {
        data = [data] // 如果数据不是数组，将其转换为数组
      }
      const statements = data.map(item => {
        const columns = Object.keys(item).map(key => `\`${key}\``).join(', ')
        const values = Object.values(item).map(value => {
          if (value === null || value === undefined) {
            return 'NULL'
          } else if (typeof value === 'string') {
            return `'${value.replace(/'/g, "''")}'` // 处理字符串中的单引号
          } else if (typeof value === 'boolean') {
            return value ? 1 : 0 // 将布尔值转换为 0 或 1
          } else {
            return value // 数字或其他类型直接使用
          }
        }).join(', ')
        return `INSERT INTO \`${tableName}\` (${columns}) VALUES (${values});`
      })
      return statements.join('\n')
    },

    downloadInsertStatementsAsFile (tableName, data, fileName = 'insert_statements.sql') {
      // 生成 INSERT 语句
      const insertStatement = this.generateInsertStatement(tableName, data)
      // 创建 Blob 对象
      const blob = new Blob([insertStatement], { type: 'text/plain' })
      // 创建下载链接
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = fileName
      // 触发下载
      link.click()
      // 释放 URL 对象
      URL.revokeObjectURL(link.href)
    },

    exportInsert (table) {
      this.downloadInsertStatementsAsFile(table, this.results[this.log ? this.sqlTab - 1 : this.sqlTab].res, `${table}-${(new Date()).valueOf()}.sql`)
    },

    resTabOnChange (page, resTab) {
      resTab.page = page
      this.tableKey = Math.random()
    }
  }
}
</script>

<style scoped>

</style>
